// extracted by mini-css-extract-plugin
export var container = "_aj-1";
export var cornerButtonContainer = "_aj-5";
export var disabled = "_aj-2";
export var fileContainer = "_aj-4";
export var hiddenInput = "_aj-3";
export var widthContainer = "_aj-0";